import cx from 'classnames';
import { css } from 'emotion';
import React, { PureComponent } from 'react';
import { colors, fontSize, mq } from './../../../../css';
import ExpertKnowledge from './expert_knowledge.svg';
import ExternalData from './external_data.svg';
import Forecast from './forecast.svg';
import HistoricalData from './historical_data.svg';
import InternalData from './internal_data.svg';
import Monitoring from './monitoring.svg';
import Rules from './rules.svg';
import Segmentation from './segmentation.svg';
import Logo from './logo.svg';

export default class EcoSystem extends PureComponent {
    constructor() {
        super();
    }

    render() {
        return (
            <div className={s.wrapper}>
                <div
                    className={cx(s.element, s.expertKnowledge)}
                    data-tag="Expert Knowledge">
                    <ExpertKnowledge />
                </div>
                <div
                    className={cx(s.element, s.externalData)}
                    data-tag="External Data">
                    <ExternalData />
                </div>
                <div
                    className={cx(s.element, s.segmentation)}
                    data-tag="Segmentation">
                    <Segmentation />
                </div>
                <div
                    className={cx(s.element, s.internalData)}
                    data-tag="Internal Data">
                    <InternalData />
                </div>
                <Logo className={s.logo} />
                <div
                    className={cx(s.element, s.monitoring)}
                    data-tag="Monitoring">
                    <Monitoring />
                </div>
                <div className={cx(s.element, s.forecast)} data-tag="Forecast">
                    <Forecast />
                </div>
                <div className={cx(s.element, s.rules)} data-tag="Rules">
                    <Rules />
                </div>
                <div
                    className={cx(s.element, s.historicalData)}
                    data-tag="Historical Data">
                    <HistoricalData />
                </div>
            </div>
        );
    }
}

const s = {};

s.wrapper = css`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: flex-start;
    overflow: hidden;
    ${mq({
        marginTop: [-50, -50, 0, 50, 0],
        marginBottom: [50],
    })};
`;

s.logo = css`
    margin-top: 30px;
    margin-bottom: 10px;
    width: 100%;
    height: 50px;
`;

s.element = css`
    position: relative;
    margin-bottom: 20px;
    ${mq({
        marginLeft: [10, 20],
        marginRight: [10, 20],
        width: ['calc(50% - 20px)', 'calc(25% - 40px)'],
        height: [150],
    })};
    &::after {
        content: attr(data-tag);
        position: absolute;
        top: calc(95%);
        left: 50%;
        transform: translateX(-50%);
        width: 110%;
        text-align: center;
        color: ${colors.blue};
        ${mq({
            fontSize: [fontSize(12), fontSize(12)],
        })};
    }
    svg {
        position: absolute;
        width: 100%;
        height: 90%;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        ${mq({
            maxWidth: [100],
        })};
    }
`;

s.expertKnowledge = css``;

s.externalData = css`
    svg {
        bottom: -15px;
    }
`;

s.segmentation = css``;

s.internalData = css`
    svg {
        bottom: -15px;
    }
`;

s.monitoring = css``;

s.forecast = css``;

s.rules = css``;

s.historicalData = css``;



// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/ecoSystem/ecoSystem.simple.component.js